import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Table} from '..';
import {openModal} from '../../actions';
import {useTableSort} from '../../utils/sortUtilities';
import Spinner from '../Spinner';

const HEAD_CELLS = [
  {
    id: 'name',
    numeric: false,
    disabledPadding: true,
    label: 'Garage Name',
  },
  {
    id: 'entranceNames',
    numeric: false,
    disabledPadding: false,
    label: 'Entrances',
  },
  {
    id: 'createdBy',
    numeric: false,
    disabledPadding: false,
    label: 'Created by',
  },
  {
    id: 'createdAt',
    numeric: false,
    disabledPadding: true,
    label: 'Created at',
  },
];

const DATA_CELLS = ['name', 'entranceNames', 'createdBy', 'createdAt'];

// Clicking a row opens the edit modal (garages have no details page of their own).
const GaragesTable = ({garages, loading, hideAddButton}) => {
  const dispatch = useDispatch();
  const {buildingById} = useSelector(s => s.buildings);
  const tableOrder = useTableSort('asc', 'createdAt');

  const onRowClick = garage => {
    dispatch(
      openModal('EditGarageModal', {buildingID: garage.buildingId, garage}),
    );
  };

  const onAddGarage = () => {
    dispatch(openModal('AddGarageModal', {buildingID: buildingById.id}));
  };

  if (loading) {
    return <Spinner />;
  }

  return (
    <Table
      data={garages}
      dataCells={DATA_CELLS}
      headCells={HEAD_CELLS}
      onRowClick={onRowClick}
      getObject
      onAdd={!hideAddButton ? onAddGarage : null}
      noToolbar={hideAddButton}
      {...tableOrder}
    />
  );
};

export default GaragesTable;
